export default "__VITE_ASSET__CxPXAH6k__"